// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".49d962997f3933a3a2675c67c8ea1b2591331f6e.chunk.js";
};